<template>
  <CModal
      :centered="true"
      :show.sync="viewExamQuestionModal"
      class="text-right"
      size="md"
      title="مشاهده سوال"
  >
    <div class="d-flex flex-column align-items-start h-100">
      <div v-if="imagePreview" class="image-preview">
        <div class="bg-shadow"></div>
        <img :src="imagePreview" class="" @click="imagePreview = null"/>
      </div>
      <div class="question__title bold mb-3">
        {{ question.text }} ({{ question.level }})
      </div>
      <div v-if="filterQuestionVideos" class="flex-fill">
        <video class="media-video__wrapper" controls>
          <source v-if="question.fileUrl" :src="question.fileUrl"/>
        </video>
      </div>
      <div v-if="filterQuestionAudios" class="flex-fill">
        <audio class="media-audio__wrapper" controls>
          <source v-if="question.fileUrl" :src="question.fileUrl"/>
        </audio>
      </div>
      <div
          v-if="filterQuestionImages"
          class="media-image__wrapper flex-fill mx-2"
      >
        <img
            v-if="question.fileUrl"
            :src="question.fileUrl"
            alt=""
            @click="imagePreview = question.fileUrl"
        />
      </div>

      <div v-else-if="question.fileUrl" class="download-file ml-3 my-2">
        <a :href="question.fileUrl" download="" target="_blank">
          <CIcon name="cil-file"/>
        </a>
      </div>
      <!--         MULTI_CHOICES questions-->

      <div v-if="question.type === 'MULTI_CHOICES'" class="mb-3">
        <div class="bold my-2">گزینه ها:</div>
        <div
            v-for="(choice, index) in question.choices"
            :key="index"
            class="my-2"
        >
          <div v-if="choice !== ''">
            {{ index + 1 }}.
            <img
                v-if="choice.includes('http')"
                :src="choice"
                class="choice-image ml-2"
                @click="imagePreview = choice"
            />
            <span v-else class="ml-2"> {{ choice }}</span>
            <span v-if="index === question.correctAnswerIndex" class="bold success">(پاسخ صحیح)</span>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <CButton color="primary" @click="viewExamQuestionModal = false"> بستن</CButton>
    </template>
  </CModal>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
    },
    question: {
      type: Object,
    },
  },
  data() {
    return {
      imagePreview: null,
    }
  },
  computed: {
    viewExamQuestionModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    filterQuestionImages() {
      return this.question.fileUrl
          ? this.question.fileUrl.toLowerCase().includes("jpg")
          : "" || this.question.fileUrl
              ? this.question.fileUrl.toLowerCase().includes("png")
              : "" || this.question.fileUrl
                  ? this.question.fileUrl.toLowerCase().includes("jpeg")
                  : "" || this.question.fileUrl
                      ? this.question.fileUrl.toLowerCase().includes("bmp")
                      : "" || this.question.fileUrl
                          ? this.question.fileUrl.toLowerCase().includes("tiff")
                          : "" || this.question.fileUrl
                              ? this.question.fileUrl.toLowerCase().includes("gif")
                              : "" || this.question.fileUrl
                                  ? this.question.fileUrl.toLowerCase().includes("svg")
                                  : ""

    },
    filterQuestionVideos() {
      return this.question.fileUrl
          ? this.question.fileUrl.toLowerCase().includes("mp4")
          : "" || this.question.fileUrl
              ? this.question.fileUrl.toLowerCase().includes("mkv")
              : "" || this.question.fileUrl
                  ? this.question.fileUrl.toLowerCase().includes("avi")
                  : "" || this.question.fileUrl
                      ? this.question.fileUrl.toLowerCase().includes("mov")
                      : "" || this.question.fileUrl
                          ? this.question.fileUrl.toLowerCase().includes("webm")
                          : "" || this.question.fileUrl
                              ? this.question.fileUrl.toLowerCase().includes("flv")
                              : ""

    },
    filterQuestionAudios() {
      return this.question.fileUrl
          ? this.question.fileUrl.toLowerCase().includes("mp3")
          : "" || this.question.fileUrl
              ? this.question.fileUrl.toLowerCase().includes("ogg")
              : "" || this.question.fileUrl
                  ? this.question.fileUrl.toLowerCase().includes("m4a")
                  : "" || this.question.fileUrl
                      ? this.question.fileUrl.toLowerCase().includes("aac")
                      : "" || this.question.fileUrl
                          ? this.question.fileUrl.toLowerCase().includes("wav")
                          : ""

    },
  },


};
</script>

<style lang="scss" scoped>
.question__title {
  overflow-wrap: break-word;
  white-space: pre-line;
}

.media-image__wrapper {
  position: relative;

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
    @media (max-width: 768px) {
      min-width: 100%;
      max-width: 100%;
    }
  }
}

.media-video__wrapper {
  position: relative;
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.media-audio__wrapper {
  position: relative;
}

.question__wrapper {
  border-bottom: 1px solid #d8dbe0;
  padding: 8px 0;
}

.choice-image {
  height: 150px;
  width: auto;
  max-width: calc(100% - 50px);
  object-fit: contain;
  border-radius: 8px;
  cursor: pointer;
}

.image-preview {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 2000;
  display: flex;
  justify-content: center;
  width: 100vw;
  max-height: 100vh;

  .bg-shadow {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: #000000cc;
  }

  img {
    width: 90%;
    height: auto;
    object-fit: contain;
    z-index: 3000;
  }
}
</style>